import { render, staticRenderFns } from "./WorkGroupEdit.vue?vue&type=template&id=617a52db"
import script from "./WorkGroupEdit.vue?vue&type=script&lang=js"
export * from "./WorkGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports